<!--
 * @Author: your name
 * @Date: 2020-06-29 09:54:46
 * @LastEditTime: 2020-06-29 16:42:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-manage-web\src\App.vue
--> 
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
  };
</script>

<style lang="scss">
  @import './style/common.scss';
  #app {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
</style>
